module.exports = __webpack_public_path__ + "static/media/17import-38.5fa09b65.xlsx";